export const SECTION = {
  PICO3: "Pico3",
  LTE: "漏水みはり番",
  ALL: "Pico3+漏水みはり番",
};

export const TABLE_STYLE = {
  ONE_SECTION: { minHeight: "60vh" },
  TOW_SECTIONS: { height: "28vh" },
};
